import { combineReducers } from 'redux';
import etapesReducer from './etapesReducer';

const etapes = combineReducers({
    etapes: etapesReducer,
});

export default etapes;
